import { Button } from 'primereact/button';
import { useEffect, useState, useRef } from 'react'
import './DigitalRPQRView.scss'
import {
    getDataDecriptPublic as getDataDecript, 
    getDigitalRPMarkRecordPublic as getDigitalRPMarkRecord, 
    getPdfDigitalRpByUUIDPublic as getPdfDigitalRpByUUID, 
    setDigitalRpAsUsedPublic as setDigitalRpAsUsed, 
    findDigitalRPPDFByCodeBarPublic as findDigitalRPPDFByCodeBar 
} from '../../servicesHooks/DigitalRP/useDigitalRPPublicService';
import { useIntl } from 'react-intl';
import { InputTextCustom, Modal } from 'medere-ui-framework';
import JsBarcode from 'jsbarcode';


export default function DigitalRPQRView() {
    const [invalidDigitalRPCode,setInvalidDigitalRPCode]=useState(false);
    const [pharmacyString,setpharmacyString]=useState("");
    const [completeModalVisibility,setCompleteModalVisibility]=useState(false);
    const [completeRpIdModalVisibility,setCompleteRpIdModalVisibility]=useState(false);

    const [rpId,setRpId]=useState<string>('');
    const [rpIdValidated,setRpIdValidated]=useState(false);
    const [, setDigitalRpDTO]=useState<any>();

    const [isUsed,setIsUsed]=useState(false);
    const [rpData,setRpData]:any=useState(null);
    //const [queryReturn,setQueryReturn]=useState(false);
    
    const [professional,setProfessional] :any=useState(false);
    const [patient,setPatient] : any=useState(false);
    const [digitalRPId,setDigitalRPId] : any=useState(false);
    const [ErrorRegisterAsUsed,setErrorRegisterAsUsed]=useState(false);
    const [errorDownload,setErrorDownload]=useState(false);

    const [registeredRecipeText, setRegisteredRecipeText] = useState('')
    const barcodeRef = useRef(null);

    useEffect(()=>{
            const params = new URLSearchParams(window.location.search);
            let professional :any=params.get('professional');
            let digitalRPuuid : any = params.get('digitalRPId');
            let patient : any=params.get('patient')
            setRegisteredRecipeText(intl.formatMessage({id:"RegisteredPrescription"}))
            if (professional && patient && digitalRPuuid){
                getDataDecript(professional,patient,digitalRPuuid).then(res=>{
                    setProfessional(res.professional)
                    setPatient(res.patient)
                    setDigitalRPId(res.uuid)
                    getDigitalRPMarkRecord(res.uuid).then((res:any)=>{
                        setRpData(res.data);
                        setRpIdValidated(true)
                        if(res.data.digitalRpUUID)
                            setIsUsed(true);
                    })
                    setRegisteredRecipeText(intl.formatMessage({id:"RecipeAlreadyIssued"}))
                })
            }
    }, []);

    useEffect(() => {
        if (rpData?.codeBar) {
            JsBarcode(barcodeRef.current, rpData.codeBar, {
                format: "CODE128",
                displayValue: true
            });
        }
    }, [rpData]);

    function downloadDigitalRp(){
        try{
       
            getPdfDigitalRpByUUID(digitalRPId).then(res=>{
                if(!res){
                    setErrorDownload(true)
                }
            })
        }catch(err){
            
        }
    }
    
    function registerDigitalRp(){
    
        if(pharmacyString==="")
            setCompleteModalVisibility(true);
        else{
            console.log(digitalRPId)
            setDigitalRpAsUsed(digitalRPId,pharmacyString).then((res:any)=>{
                if(res===true){
                    console.log(digitalRPId)
                    getDigitalRPMarkRecord(digitalRPId).then((res:any)=>{
                        setRpData(res.data);
                        if(res.data?.digitalRpUUID){
                            setRpIdValidated(true)
                            setIsUsed(true)
                        }
                    })
                }else{
                    setErrorRegisterAsUsed(true)
                }
            })
        }
    }

    function handleValidateRecipe() {
        if (rpId==="")
            setCompleteRpIdModalVisibility(true)
        else {
            findDigitalRPPDFByCodeBar(rpId).then((res:any)=>{
                if(!res){
                    setInvalidDigitalRPCode(true)
                    return
                }
                console.log('Escribimos el '+res.digitalRpUUID)
                setDigitalRPId(res.digitalRpUUID)
                getDigitalRPMarkRecord(res.digitalRpUUID).then((resp:any)=>{
                    console.log(resp.data)
                    setRpData(resp.data);
                    if(resp.data?.digitalRpUUID)
                        setIsUsed(true);
                    else{
                        setDigitalRpDTO(resp.data)
                        setIsUsed(false)
                        digitalRPId                   
                    }
                    setRpIdValidated(true) 
                })
                console.log('Estamos aca')
            }).catch(() => {
                setInvalidDigitalRPCode(true)
            })
        }
    }

    // const {siteLogo} = useSelector((state: RootState) => state.site);
    const intl = useIntl();

    return (
    <div style={{justifyContent:'center'}} className='flexible--column viewContainer'>
        {/* { siteLogo!='' && <img style={{marginTop:'10px',alignSelf:'center',width:'90px',height:'90px'}} src={`/mimg/mederelogo.png`} alt="" className='img' /> } */}
        <div className='flexible--row prescription-register-container'>
        <div className='flexible--column inner-container'>
            { !rpIdValidated && <div className='div-content'>
                                    <p style={{fontSize:'32px',marginBottom:'8px'}} className='textBold infoText'>{intl.formatMessage({id:"RegisterPrescription"})}</p>
                                    <InputTextCustom value={rpId} onChange={(e:any)=>{
                                        setRpId(e.target.value);
                                    }} label="Id Receta" />
                                    <div style={{justifyContent:'flex-end',marginTop:'24px'}} className='flexible--row'>
                                        <Button style={{marginLeft:'16px'}} onClick={handleValidateRecipe} className='buttonMain' label="Validar receta"/>
                                    </div>
                                </div>
            }
            { rpIdValidated && !isUsed &&  <div className='div-content'>
                <p style={{fontSize:'32px',marginBottom:'8px'}} className='textBold infoText'>{intl.formatMessage({id:"RegisterPrescription"})}</p>
                <p style={{alignSelf:'center',paddingBottom:'8px'}}  className='textBold m-bottom'>
                    {intl.formatMessage({id:"IssuedFor"})} <span className='textDark'>{patient}</span> {intl.formatMessage({id:"By"})} <span className='textDark'>{professional}</span></p>
                <InputTextCustom value={pharmacyString} onChange={(e:any)=>{
                    setpharmacyString(e.target.value);
                }} label="Farmacia" placeholder="Nombre" ></InputTextCustom>
                <div style={{justifyContent:'flex-end',marginTop:'24px'}} className='flexible--row'>
                    <Button onClick={downloadDigitalRp} className='buttonMain2' label="Descargar"/>
                    <Button style={{marginLeft:'16px'}} onClick={registerDigitalRp} className='buttonMain' label="Registrar receta"/>
                </div>
            </div>
            }
            {rpData && <div className='flexible--column div-content'>
                <p style={{fontSize:'32px',marginBottom:'8px'}} className='textBold infoText'>{registeredRecipeText}</p>
                <div style={{marginBottom:'16px',borderBottom:'1px solid black'}}className='width-100'></div>
                <p className='textBold textDark' >Id {intl.formatMessage({id:"Prescription"})}</p>
                <svg ref={barcodeRef}></svg>{/*<p className='m-bottom'>{rpData?.digitalRpUUID}</p> */}
                <p className='textBold textDark'>{intl.formatMessage({id:"DateAndTime"})}</p>
                <p className='m-bottom'>{intl.formatDate(rpData?.rpDate, {day:'2-digit', month:'2-digit', year:'numeric',hour:'2-digit',minute:'2-digit'}) }</p>
                <p className='textBold textDark'>{intl.formatMessage({id:"Professional"})}</p>
                <p className='m-bottom'>{rpData?.professional}</p>
                <p className='textBold textDark'>{intl.formatMessage({id:"Patient"})} </p>
                <p className='m-bottom'>{rpData?.patientName}</p>
                <p className='textBold textDark'>{intl.formatMessage({id:"Registered"})}</p>
                <p className='m-bottom'>{intl.formatDate(rpData?.date, {day:'2-digit', month:'2-digit', year:'numeric',hour:'2-digit',minute:'2-digit'}) }</p>
                <p className='textBold textDark'>{intl.formatMessage({id:"Pharmacy"})}</p>
                <p className='m-bottom'>{rpData?.identification}</p>
            </div>}
            
        </div>
        </div>
        <Modal header="Para continuar" visible={completeModalVisibility} setVisible={setCompleteModalVisibility}>
            {intl.formatMessage({id:"PleaseFillPharmacyName"})}
        </Modal>
        <Modal header="Error" visible={ErrorRegisterAsUsed} setVisible={setErrorRegisterAsUsed}>
            {intl.formatMessage({id:"FailedToRegisterPrescription"})}
        </Modal>
        <Modal header="Error" visible={errorDownload} setVisible={setErrorRegisterAsUsed}>
            {intl.formatMessage({id:"FailedToRegisterPrescription"})}
        </Modal>
        <Modal header="Para continuar" visible={completeRpIdModalVisibility} setVisible={setCompleteRpIdModalVisibility}>
            {intl.formatMessage({id:"PleaseFillTheRpId"})}
        </Modal>
        <Modal header="Codigo inválido" visible={invalidDigitalRPCode} setVisible={setInvalidDigitalRPCode}>
            {intl.formatMessage({id:"InvalidDigitalRPCode"})}
        </Modal>
    </div>
  )
}
